import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { LeftNavPortalPageComponent } from './pages/left-nav-portal-page/left-nav-portal-page.component';
import { UserContextResolver } from './services/user-context/user-context.resolver';
import { benefitsRoutes } from './app-routing.routes';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { NoAccessPageComponent } from './pages/no-access-page/no-access-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { ListPoliciesPageComponent } from './pages/list-policies-page/list-policies-page.component';
import { PolicyContextResolver } from './services/policy-context/policy-context.resolver';
import { NavPortalPageComponent } from './pages/nav-portal-page/nav-portal-page.component';
import { ReportViewerComponent } from './pages/claim-page/report-viewer/report-viewer.component';
import { AddEmployeeComponent } from './pages/employee-page/add/add.component';
import { DemoLoginPageComponent } from './pages/demologin-page/demologin-page.component';

const routes: Routes = [
  {
    path: 'landing',
    data: { title: 'Landing' },
    component: LandingPageComponent
  },
  {
    path: 'login',
    data: { title: 'Login' },
    component: LoginPageComponent
  },
  {
    path: 'authorize',
    data: { title: 'Login' },
    component: LoginPageComponent
  },
  {
    path: 'demologin',
    data: { title: 'DEMO Log In' },
    component: DemoLoginPageComponent
  },
  {
    path: 'benefits/claims/report-viewer',
    data: { title: 'Report Viewer' },
    component: ReportViewerComponent
  },
  {
    path: 'benefits/employees/add-form',
    component: AddEmployeeComponent,
    resolve: {
      userContext: UserContextResolver,
      policyContext: PolicyContextResolver
    },
    data: { headerText: 'Add employee' }
  },
  {
    path: 'benefits',
    component: LeftNavPortalPageComponent,
    resolve: {
      userContext: UserContextResolver
    },
    children: [
      {
        path: '',
        data: { routes: benefitsRoutes },
        resolve: {
          policyContext: PolicyContextResolver
        },
        component: HomePageComponent,
        children: [
          ...benefitsRoutes.map(({ path, component, loadChildren, text, children, data }) => ({
            path,
            component: component,
            data: { pageHeader: text, title: text, logoText: '', headerText: data?.headerText, ...data },
            loadChildren,
            children: children?.map(({ path, component, redirectTo, pathMatch, text, data }) => ({
              path,
              redirectTo,
              pathMatch,
              component,
              data: { pageHeader: text, ...data }
            }))
          }))
        ]
      }
    ]
  },
  {
    path: 'benefits',
    component: NavPortalPageComponent,
    resolve: {
      userContext: UserContextResolver
    },
    children: [
      {
        path: 'search',
        component: ListPoliciesPageComponent,
        data: { title: 'Search for groups' }
      },
      {
        path: 'no-access',
        component: NoAccessPageComponent,
        data: { title: 'No Access' }
      },
      {
        path: 'not-found',
        component: NotFoundPageComponent,
        data: { title: 'Policy Not Found' }
      },
      {
        path: 'error',
        component: ErrorPageComponent,
        data: { title: 'Error' }
      }
    ]
  },
  { path: 'not-found', redirectTo: '/benefits/not-found', pathMatch: 'full' },
  { path: 'no-access', redirectTo: '/benefits/no-access', pathMatch: 'full' },
  { path: 'error', redirectTo: '/benefits/error' },
  { path: '', redirectTo: '/benefits/search', pathMatch: 'full' },
  { path: '**', redirectTo: '/benefits/search', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
